/* ChewNectar product page buy box v9: quantity, three purchase options (one-time, subscribe, stock-up),
   delivery frequency, gallery, add-ons and sticky bar. Subscription cards switch on only when matching
   Shopify selling plans exist for the variant. Runs once the DOM is ready (the script tag sits above the buy box). */
(() => {
  const init = () => {
    const root = document.querySelector('[data-pdp]');
    if (!root) return;
    const fmt = (c) => {
      const whole = Math.round(c) % 100 === 0;
      return '\u20B9' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    };
    const form = root.querySelector('[data-pdp-form]');
    const atc = root.querySelector('[data-pdp-atc]');
    const label = root.querySelector('[data-pdp-label]');
    const totEl = root.querySelector('[data-pdp-total]');
    const sum = root.querySelector('[data-pdp-sum]');
    const qnote = root.querySelector('[data-qty-note]');
    const cards = [...root.querySelectorAll('.pc')];
    const qtyBtns = [...root.querySelectorAll('[data-qty]')];
    const extra = root.dataset.sumExtra || '';
    let qty = 1;
    let opt = 'once';
    const days = { sub: null, stock: null };
    const map = { sub: {}, stock: {} };
    let plans = [];
    try { plans = JSON.parse((root.querySelector('#pdp-plans') || {}).textContent || '[]'); } catch (e) { plans = []; }
    plans.forEach((p) => {
      const n = String(p.name || '').toLowerCase();
      const m = n.match(/(\d+)\s*days?/);
      if (!m || n.includes('bundle')) return;
      const g = n.includes('stock') ? 'stock' : (n.includes('subscribe') ? 'sub' : null);
      if (g) map[g][m[1]] = p.id;
    });
    cards.forEach((c) => {
      const k = c.dataset.opt;
      if (k === 'once') return;
      const have = Object.keys(map[k]);
      if (!have.length) { c.classList.add('is-off'); c.setAttribute('aria-disabled', 'true'); c.tabIndex = -1; return; }
      const soon = c.querySelector('[data-soon]');
      if (soon) soon.hidden = true;
      c.querySelectorAll('[data-day]').forEach((b) => { if (!map[k][b.dataset.day]) b.hidden = true; });
      const first = c.querySelector('[data-day]:not([hidden])');
      days[k] = first ? first.dataset.day : have[0];
    });
    const cur = () => cards.find((c) => c.dataset.opt === opt);
    const update = () => {
      const c = cur();
      const unit = Number(c.dataset.price) || 0;
      const total = opt === 'stock' ? unit : unit * qty;
      cards.forEach((x) => {
        const on = x === c;
        x.setAttribute('aria-checked', on ? 'true' : 'false');
        x.classList.toggle('is-on', on);
        const f = x.querySelector('.pc__f');
        if (f) f.hidden = !on || x.classList.contains('is-off');
        x.querySelectorAll('[data-day]').forEach((b) => b.setAttribute('aria-pressed', String(on && b.dataset.day === days[x.dataset.opt])));
      });
      qtyBtns.forEach((b) => { b.disabled = opt === 'stock'; b.setAttribute('aria-pressed', String(opt !== 'stock' && Number(b.dataset.qty) === qty)); });
      if (qnote) qnote.hidden = opt !== 'stock';
      if (label) label.textContent = opt === 'once' ? 'Add to cart' : 'Subscribe';
      if (totEl) totEl.textContent = fmt(total);
      const sp = document.querySelector('[data-pdp-sp]');
      const sw = document.querySelector('[data-pdp-sw]');
      if (sp) sp.textContent = fmt(total);
      if (sw) sw.textContent = '';
      const sb = document.querySelector('[data-pdp-sbtn]');
      if (sb) sb.textContent = opt === 'once' ? 'Add to cart' : 'Subscribe';
      if (sum) {
        if (opt === 'once') { sum.hidden = true; sum.textContent = ''; }
        else { sum.hidden = false; sum.textContent = fmt(total) + ' charged every ' + days[opt] + ' days until cancelled. Shipping calculated at checkout.' + (extra ? ' ' + extra : ''); }
      }
    };
    const choose = (c) => { if (c.classList.contains('is-off')) return; opt = c.dataset.opt; update(); };
    cards.forEach((c) => {
      c.addEventListener('click', (e) => {
        const d = e.target.closest('[data-day]');
        if (d) { if (c.classList.contains('is-off')) return; days[c.dataset.opt] = d.dataset.day; opt = c.dataset.opt; update(); return; }
        choose(c);
      });
      c.addEventListener('keydown', (e) => { if ((e.key === ' ' || e.key === 'Enter') && e.target === c) { e.preventDefault(); choose(c); } });
    });
    qtyBtns.forEach((b) => b.addEventListener('click', () => { qty = Number(b.dataset.qty); update(); }));
    const main = root.querySelector('[data-pdp-main]');
    root.querySelectorAll('.pgal__thumbs button').forEach((b) => b.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = b.dataset.src;
      main.alt = b.dataset.alt;
      root.querySelectorAll('.pgal__thumbs button').forEach((x) => x.setAttribute('aria-current', x === b));
    }));
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const item = { id: Number(form.querySelector('[name=id]').value), quantity: opt === 'stock' ? Number(cur().dataset.jars || 2) : qty };
        if (opt !== 'once') item.selling_plan = Number(map[opt][days[opt]]);
        atc.setAttribute('aria-busy', 'true');
        try { await window.cnAddToCart([item]); } finally { atc.removeAttribute('aria-busy'); }
      });
    }
    root.querySelectorAll('[data-pdp-addon]').forEach((b) => b.addEventListener('click', async () => {
      const was = b.textContent;
      b.setAttribute('aria-busy', 'true');
      await window.cnAddToCart([{ id: Number(b.dataset.pdpAddon), quantity: 1 }]);
      b.removeAttribute('aria-busy');
      b.textContent = 'Added';
      setTimeout(() => { b.textContent = was; }, 1800);
    }));
    const sticky = document.querySelector('[data-pdp-sticky]');
    const sbtn = document.querySelector('[data-pdp-sbtn]');
    if (sbtn) sbtn.addEventListener('click', () => atc.click());
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      }).observe(atc);
    }
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();